module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "finsh-page"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "offset": 6
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('div', {
    staticClass: "section"
  }, [(_vm.viewType === 'success') ? _c('div', [_c('el-alert', {
    attrs: {
      "title": _vm.$t('rechargeFinish'),
      "type": "success",
      "description": _vm.$t('rechargeFinishCheckLater'),
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "text item"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('orderId')) + ": " + _vm._s(_vm.order_id))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('rechargeAmount')) + ": " + _vm._s(_vm.recharge_amount) + " " + _vm._s(_vm.currency))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.viewType === 'finsh') ? _c('div', [_c('el-alert', {
    attrs: {
      "title": _vm.$t('rechargeFinish'),
      "type": "success",
      "description": _vm.$t('rechargeFinishCheckLater'),
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "text item"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('orderId')) + ":" + _vm._s(_vm.order_id))]), _vm._v(" "), _c('br')])])], 1) : _vm._e(), _vm._v(" "), (_vm.viewType === 'fail') ? _c('div', [_c('el-alert', {
    attrs: {
      "title": _vm.$t('rechargeFail'),
      "type": "warning",
      "description": _vm.$t('rechargeFailErrCode'),
      "show-icon": ""
    }
  }), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', [_vm._v("code: " + _vm._s(_vm.code))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('orderId')) + ": " + _vm._s(_vm.order_id))])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "test"
    },
    on: {
      "click": _vm.heights
    }
  }, [_vm._v("位置")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "close"
    },
    on: {
      "click": _vm.closes
    }
  }, [_vm._v("关闭")])])])])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a66377c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Result.vue
// module id = 383
// module chunks = 10